import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { TkvActions } from '../tkvActions';

export function* handleTkvNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    TkvActions.HANDLE_TKV_NAVIGATION_TO_ANGEBOT,
    safeSaga(handleTkvNavigationToAngebot, App.TKV),
  );
}

export function* handleTkvNavigationToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.TKV,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationResult,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (
    !(
      contractAppId === App.TKV &&
      contractAngebotsId === state.angebotsId &&
      contractValidationResult == null
    )
  ) {
    return;
  }

  yield put(new TkvActions().quoteDBRequested());
  yield put(new TkvActions().preiseRequested());
  yield put(new TkvActions().zumAngebotButtonClicked());
  const navRoute: NavigationRoute = {
    appId: App.TKV,
    subroute: AppSubroute.TAA_ANGEBOT,
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
